import { useEffect } from 'react'
import { Route, Routes, useNavigate } from 'react-router-dom'
import Sidebar from '../components/menus/Sidebar'
import { useAuth } from '../components/auth/useAuth'
import i18n from 'i18next'
import MenuClerk from '../components/menus/MenuClerk'
import TopBar from '../components/menus/TopBar'
import NothingHere from '../pages/error/NothingHere'
import Dashboard from '../pages/clerk/Dashboard'
import Clients from '../pages/Clients'
import Policies from '../pages/Policies'
import Sinesters from '../pages/Sinesters'
import Receipts from '../pages/Receipts'
import Documents from '../pages/Documents'
import Reports from '../pages/Reports'
import Settings from '../pages/clerk/Settings'
import ClientDetail from '../pages/ClientDetail'
import PolicyDetail from '../pages/PolicyDetail'
import SinesterDetail from '../pages/SinesterDetail'
import ReceiptDetail from '../pages/ReceiptDetail'

const t = i18n.t.bind(i18n)

export default function ClerkRouter() {
	const navigate = useNavigate()
	const { clientauth } = useAuth()

	useEffect(() => {
		let token = localStorage.getItem('jwt')

		if (!token) {
			navigate(`/${t("url.auth.login")}`)
		}
	}, [navigate])

	const clerkRoutesAlias = {
		"": "calendar",
		[t("url.dashboard")]: "dashboard",
		[t("url.clients")]: "clients",
		[`${t("url.clients")}/:id`]: "clientDetail",
		[t("url.policies")]: "policies",
		[`${t("url.policies")}/:id`]: "policyDetail",
		[t("url.sinesters")]: "sinesters",
		[`${t("url.sinesters")}/:id`]: "sinesterDetail",
		[t("url.receipts")]: "receipts",
		[`${t("url.receipts")}/:id`]: "receiptDetail",
		[t("url.documents")]: "documents",
		[t("url.reports")]: "reports",
		[t("url.settings")]: "settings"
	}

	const getComponentClerk = (path: string) => {
		switch (path) {
			case "dashboard": return <Dashboard />;
			case "clients": return <Clients />;
			case "clientDetail": return <ClientDetail />;
			case "policies": return <Policies />;
			case "policyDetail": return <PolicyDetail />;
			case "sinesters": return <Sinesters />;
			case "sinesterDetail": return <SinesterDetail />;
			case "receipts": return <Receipts />;
			case "receiptDetail": return <ReceiptDetail />;
			case "documents": return <Documents />;
			case "reports": return <Reports />;
			case "settings": return <Settings />;
			default: return <NothingHere />;
		}
	}

	return (
		<div className="app-shell">
			<TopBar rol={clientauth?.rol ?? ""} isAdmin={clientauth?.isAdmin ?? false} />
			<div className="app-shell__body">
				<Sidebar rol={clientauth?.rol ?? ""} isAdmin={clientauth?.isAdmin ?? false} />
				<div className="app-content py-4 py-lg-5">
					<MenuClerk />
					<Routes>
						{Object.entries(clerkRoutesAlias).map(([alias, path]) => (
							<Route key={alias} path={alias} element={getComponentClerk(path)} />
						))}
						<Route path="*" element={<NothingHere />} />
					</Routes>
				</div>
			</div>
		</div>
	)
}